<template>
  <div>
    <v-container v-if="action" class="pt-0">
      <span class="headline">{{getActionName(action)}}</span>
      <v-row v-if="$store.state.isLoggedIn">
        <v-col v-if="action.performLabel">
          <v-btn class="primary" @click="performAction">
            <v-icon left>mdi-check-bold</v-icon>
            {{action.performLabel}}
          </v-btn>
        </v-col>
      </v-row>
      <action-details :action="action" />
      <v-row>
        <v-col cols="12">
          <alert v-if="action.message" :text="action.message" :type="action.messageType"></alert>
        </v-col>
      </v-row>
      <v-row v-if="$store.state.isLoggedIn">
        <v-col v-if="action.performLabel">
          <v-btn class="primary" @click="performAction">
            <v-icon left>mdi-check-bold</v-icon>
            {{action.performLabel}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <alert text="Für diese Aktion musst du dich anmelden."></alert>
        </v-col>
        <v-col>
          <v-btn class="primary mr-4" link :to="loginWithRedirect(this.$route.fullPath)">
            <v-icon left>mdi-login</v-icon>Login
          </v-btn>
          <v-btn class="mr-4" link :to="registrationRouteWithRedirect(this.$route.fullPath)">
            <v-icon left>mdi-account-plus</v-icon>Registrieren
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import actionMixin from "@/mixins/actionMixin";
import commonMixin from "@/mixins/commonMixin";
import ActionDetails from "@/widgets/ActionDetails";
import Alert from "@/widgets/Alert";

export default {
  name: "ActionView",
  mixins: [actionMixin, commonMixin],
  components: {
    ActionDetails,
    Alert
  },
  props: {
    actionStr: String
  },
  data: function() {
    return {
      action: undefined
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  watch: {
    actionStr: function(val) {
      console.log("actionStr changed to " + val);
      this.reset();
      this.loadAction();
    }
  },
  mounted() {
    this.loadAction();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {
      this.loadAction();
    },
    reset() {
      this.action = undefined;
    },
    loadAction() {
      console.log(`Loading action information`);
      this.$api
        .getAction(this.actionStr)
        .then(response => {
          let data = response.data;
          this.action = data;
        })
        .catch(error => {
          this.$common.onError(error)
        });
    },
    performAction() {
      this.$api
        .performAction(this.actionStr)
        .then(response => {
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
          if (!this.performActionResult(response.data)) {
            this.loadAction();
          }
        })
        .catch(error => {
          this.$common.onError(error)
        });
    }
  }
};
</script>

<style scoped>
</style>
